module.exports = __webpack_public_path__ + "static/media/link_active.62ea1036.svg";